import * as types from '../mutation-types'

const state = {
  countries: []
}

const getters = {
  countries: (state) => state.countries
}

const mutations = {
  [types.SET_COUNTRIES](state, data) {
    state.countries = data
  }
}

const actions = {
  setCountries: ({ commit }, data) => {
    commit(types.SET_COUNTRIES, data)
  }
}

const countries = {
  state,
  getters,
  mutations,
  actions
}

export default countries
